import { EYarikanoQuestionId, TYarikanoChatItem } from '../types/yarikanoChat';

const YARIKANO_CHAT_ICON_URL =
  'https://d2mr4wvbj2vhp5.cloudfront.net/fit-in/400x400/1/admin-logo';

const YARIKANO_CHAT_CTA_URL = 'https://yk2024.com/search';

const YARIKANO_CHAT_CTA_LABEL = 'ヤリカノへ';

const YARIKANO_CHAT_TITLE = 'コスパ最強団体はヤリカノ';

const YARIKANO_CHAT_VIDEO_MIME = 'video/mp4';

/** Fixed uuid for Yarikano operator bubbles (not a real PubNub user). */
const YARIKANO_CHAT_OPERATOR_UUID = 'yarikano-chat-operator';

/** Auto-sent on first open; also the first chip id. */
const YARIKANO_CHAT_AUTO_QUESTION_ID = EYarikanoQuestionId.GROUP;

const YARIKANO_CHAT_TYPING_MS = 1000;

const YARIKANO_CHAT_STORAGE_KEY = 'yarikano_chat_session';

const YARIKANO_CHAT_ITEMS: TYarikanoChatItem[] = [
  {
    id: EYarikanoQuestionId.GROUP,
    suggestText: '団体とは？',
    answerTexts: [
      'キャスト２名以上呼んだら、お客様は何名でもOKで、みんなで遊べるコースです。\n野球拳や王様ゲームでエロ飲みで盛り上がる事も接待で利用いただくこともできます。\n料金はキャスト１名につき、1セット(60分)30,000円のみ！(別途指名料)',
    ],
    videoUrl: 'https://d1w9037vspqb7f.cloudfront.net/1/yk_group_play.mp4',
  },
  {
    id: EYarikanoQuestionId.TWO_SHOT,
    suggestText: 'ツーショットとは？',
    answerTexts: [
      'キャストと1対1で遊べるプランです。\n最初から自宅やホテルなどデリヘルのように利用いただくことも可能です。\nシーシャやサウナ、バーなどに派遣も可能で、合流場所に制限はないです。',
    ],
    videoUrl: 'https://d1w9037vspqb7f.cloudfront.net/1/yk_delivery_health.mp4',
  },
  {
    id: EYarikanoQuestionId.PHOTO,
    suggestText: '撮影OPとは？',
    answerTexts: ['えっちな事をしている時に撮影ができちゃいます。'],
  },
  {
    id: EYarikanoQuestionId.GACHA,
    suggestText: 'ガチャとは？',
    answerTexts: [
      'カノジョ達のエロい動画や最大1セット無料クーポンが当たる機能です✨\n当たった動画の子と実際に会えちゃうガチャが出来るデリヘルになってます💕',
    ],
    videoUrl: 'https://d1fc9eftud06n1.cloudfront.net/1/yarikano_gacha.mp4',
  },
  {
    id: EYarikanoQuestionId.FRANCHISE,
    suggestText: 'ヤリカノフランチャイズとは？',
    answerTexts: [
      'ヤリカノフランチャイズはデリヘル経営から面倒を全て省いたビジネスモデルとなっております！\n女の子を登録するだけで運用できるプラットフォームで、ロイヤリティはたったの40万円！\nご興味ある方はぜひ説明会にご参加くださいませ！\nhttps://yk-group.co.jp/fp/',
    ],
  },
];

const getYarikanoChatItem = (
  id: EYarikanoQuestionId,
): TYarikanoChatItem | undefined =>
  YARIKANO_CHAT_ITEMS.find((item) => item.id === id);

export {
  YARIKANO_CHAT_ICON_URL,
  YARIKANO_CHAT_CTA_URL,
  YARIKANO_CHAT_CTA_LABEL,
  YARIKANO_CHAT_TITLE,
  YARIKANO_CHAT_VIDEO_MIME,
  YARIKANO_CHAT_OPERATOR_UUID,
  YARIKANO_CHAT_AUTO_QUESTION_ID,
  YARIKANO_CHAT_TYPING_MS,
  YARIKANO_CHAT_STORAGE_KEY,
  YARIKANO_CHAT_ITEMS,
  getYarikanoChatItem,
};
